<template>
	<div class="filter">
		<div class="filter-title">
			<h1>Administradores</h1>
		</div>
		<div class="filter-inputs">
			<input
				class="filter-inputs__admins"
				type="text"
				placeholder="Busca"
				@input="searchInputDebounce"
				v-model="searchInput"
			/>
			<ButtonPrimary
				class="filter-inputs__btn"
				label="Adicionar Administrador"
				size="md"
				@click="addAdmin"
			/>
		</div>
	</div>
</template>

<script>
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';

export default {
	name: 'TableFilter',
	components: { ButtonPrimary },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		searchInput: null,
		debounce: null,
	}),
	created() {},
	mounted() {},
	methods: {
		addAdmin() {
			this.$router.push({
				path: '/dashboard/admin/detail',
			});
		},
		searchInputDebounce() {
			clearTimeout(this.debounce);

			this.debounce = setTimeout(() => {
				this.$emit('searchFromInput', this.searchInput);
			}, 600);
		},
	},
	computed: {},
};
</script>

<style lang="scss" scoped>
@import 'TableFilter.scss';
</style>
